function CleanData({
  values, choose, child, typeTree, typeModal,
}: any) {
  const procHierarcy: { [val: string]: string } = {
    1: '8383ebe4-b224-492e-94e6-5fb0f81cce51',
    2: '8383ebe4-b224-492e-94e6-5fb0f81cce52',
    3: '8383ebe4-b224-492e-94e6-5fb0f81cce53',
    4: '8383ebe4-b224-492e-94e6-5fb0f81cce54',
  };

  const getLevel = (val: any) => {
    const temp = val?.split('.');
    return temp?.length;
  };

  if (values.level === 1) {
    values.level = getLevel(child?.order) || 1;
  }

  const newTechnical = values?.func_competencies?.map((val: any) => val.competency_detail_id);
  const newBehaviour = values?.behaviour_comp?.map((val: any) => val.competency_detail_id);
  // DATA CREATE
  const data = {
    board_id: localStorage.getItem('board_id'),
    proc_hierarchy_id: procHierarcy[typeModal],
    name: values?.name,
    output: values?.output,
    objective: values?.objective,
    main_indicator: values?.main_indicator,
    technical_competencies:
      newTechnical?.length !== 0 ? newTechnical : undefined,
    behaviour_competencies:
      newBehaviour?.length !== 0 ? newBehaviour : undefined,
    parent_id:
      values?.parent_id || undefined,
  };
  if (data.technical_competencies === undefined) {
    delete data.technical_competencies;
  }
  if (data.behaviour_competencies === undefined) {
    delete data.behaviour_competencies;
  }
  // DATA CHILD
  const dataChild = {
    parent_id: values?.parent_id || child?.process_id,
    level: values?.level || choose?.level,
    name: values?.name,
    output: values?.output,
    objective: values?.objective,
    main_indicator: values?.main_indicator,
    technical_competencies: newTechnical,
    behaviour_competencies: newBehaviour,
  };
  // DATA NEXT, PREVIOUS
  const dataTree = {
    process_id: child?.process_id,
    type: typeTree,
    name: values?.name,
    output: values?.output,
    objective: values?.objective,
    main_indicator: values?.main_indicator,
    technical_competencies: newTechnical,
    behaviour_competencies: newBehaviour,
  };

  // DATA EDIT
  const dataEdit = {
    process_id: values?.process_id,
    name: values?.name,
    output: values?.output,
    objective: values?.objective,
    proc_hierarchy_id: values?.proc_hierarchy_id !== '' ? values?.proc_hierarchy_id : undefined,
    parent_id: values?.parent_id || child?.process_id,
    main_indicator: values?.main_indicator,
    technical_competencies:
      newTechnical?.length !== 0 ? newTechnical : undefined,
    behaviour_competencies:
      newBehaviour?.length !== 0 ? newBehaviour : undefined,
  };
  if (dataEdit.technical_competencies === undefined) {
    delete dataEdit.technical_competencies;
  }
  if (dataEdit.behaviour_competencies === undefined) {
    delete dataEdit.behaviour_competencies;
  }
  if (dataEdit.behaviour_competencies === undefined) {
    delete dataEdit.behaviour_competencies;
  }
  if (dataEdit.proc_hierarchy_id === undefined) {
    delete dataEdit.proc_hierarchy_id;
  }

  return {
    data, dataChild, dataTree, dataEdit,
  };
}

export default CleanData;
